module.exports = {
  "props": [
    {
      "name": "align-top",
      "type": "boolean",
      "default": "false",
      "source": "v-timeline",
      "description": {
        "en": "Align caret and dot of timeline items to the top",
        "eo-UY": ""
      }
    },
    {
      "name": "dark",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the dark theme variant to the component. You can find more information on the Material Design documentation for [dark themes](https://material.io/design/color/dark-theme.html).",
        "eo-UY": ""
      }
    },
    {
      "name": "dense",
      "type": "boolean",
      "default": "false",
      "source": "v-timeline",
      "description": {
        "en": "Hide opposite slot content, and position all items to one side of timeline",
        "eo-UY": ""
      }
    },
    {
      "name": "light",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the light theme variant to the component.",
        "eo-UY": ""
      }
    },
    {
      "name": "reverse",
      "type": "boolean",
      "default": "false",
      "source": "v-timeline",
      "description": {
        "en": "Reverse direction of timeline items",
        "eo-UY": ""
      }
    }
  ],
  "mixins": [
    "themeable"
  ],
  "slots": [
    {
      "name": "default",
      "description": {
        "en": "The default Vue slot.",
        "eo-UY": ""
      }
    }
  ],
  "events": [],
  "functions": [],
  "name": "v-timeline",
  "sass": [
    {
      "name": "$timeline-divider-center",
      "default": "50% !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-divider-width",
      "default": "96px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-item-padding",
      "default": "24px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-line-width",
      "default": "2px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-wedge-size",
      "default": "10px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-dot-small-size",
      "default": "24px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-dot-regular-size",
      "default": "38px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-dot-large-size",
      "default": "52px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-inner-dot-small-size",
      "default": "18px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-inner-dot-regular-size",
      "default": "30px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$timeline-inner-dot-large-size",
      "default": "42px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    }
  ],
  "component": true
}